import React from "react";
import "./Our_Projects.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";


const Our_Projects = () => {

  const data = [
    {
      project: "Row House Interior Design",
      location: "Alandi",
      year: "2025",
      img: "/assets/images/projects/row_house/row-thumbnail.jpeg",
    },
    {
      project: "2 BHK Apartment Interiors",
      location: "Eden Garden, Vimannagar",
      year: "2025",
      img: "/assets/images/projects/two_bhk/img7.jpeg",
    },
    {
      project: "2.5 BHK Apartment Interiors",
      location: "Kalashree Society, Nanded City",
      year: "2025",
      img: "/assets/images/projects/two_and_half_bhk/thumbnail.jpeg",
    },
    {
      project: "3 BHK Luxury Apartment Interiors",
      location: "Kalpataru, Baner",
      year: "2025",
      img: "/assets/images/projects/three_bhk/thumbnail.jpeg",
    },
    {
      project: "3 BHK Apartment Interiors",
      location: "Nico Garden, Vimannagar",
      year: "2025",
      img: "/assets/images/projects/nico_garden/thumbnail.jpeg",
    },

    {
      project: "Tesla Hi-Tech Imaging and Diagnostic Centre",
      location: "Pimpri Chinchwad",
      year: "2025",
      img: "/assets/images/projects/tesla-hi-tech/6.jpeg",
    },
    {
      project: "SP Super Speciality Clinic – Pediatric Clinic - Dr. Ashlesha Dighe",
      location: "Wakad,Pune",
      year: "2025",
      img: "/assets/images/projects/sp_super-speciality/2.jpeg",
    },
    {
      project: "Asian Institute of Men’s Health & Urology Clinic - Dr. R. K. Shimpi",
      location: "Hadapsar,Pune",
      year: "2025",
      img: "/assets/images/projects/asian_institute/3.jpeg",
    },
    

  ];

  const navigate = useNavigate();

  return (
    <section className="Our_Projects">
      <div className="container">
        <Common_Title
          pageTitle="OUR PROJECTS"
          boxText="Reimagining  "
          subText=" Designs Outside the Box "
          darkText="Showcased are our few projects innovatively crafted with precision."
        />

        <div className="swiper_div desktop_view">
          <Swiper
            spaceBetween={15}
            slidesPerView={2}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}

            modules={[Pagination,]}
            className="mySwiper"
            loop
            breakpoints={{
              0: {
                slidesPerView: 1.5,
              },
              420: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1400: {
                slidesPerView: 5,
              },
            }}
          >
            {data?.map((item, index) => {
              return (
                <SwiperSlide>
                  <div
                    className={`project_card ${index % 2 === 0 ? "even" : "odd"
                      }`}
                  onClick={() => { navigate("/projects") }}
                  >
                    <div className="inner_card">
                      <div className="outer_img_div">
                        <div className="img_holder">
                          <img src={item?.img} className="inner_img" />
                        </div>
                        <div className="overlay"></div>
                      </div>

                      <div className="info_holder">
                        <p className="project_name">{item?.project}</p>
                        <p className="loactaion">{item?.location}</p>
                        <p className="loactaion">{item?.year}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        <div className="swiper_div mobile_view">
          <Swiper
            spaceBetween={15}
            slidesPerView={2}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            autoplay={{ delay: 2000 }}
            modules={[Pagination, Autoplay]}
            className="mySwiper"
            loop
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              450: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1400: {
                slidesPerView: 5,
              },
            }}
          >
            {data?.map((item, index) => {
              return (
                <SwiperSlide>
                  <div
                    className={`project_card ${index % 2 === 0 ? "even" : "odd"
                      }`}
                  onClick={() => { navigate("/projects") }}
                  >
                    <div className="inner_card">
                      <div className="outer_img_div">
                        <div className="img_holder">
                          <img src={item?.img} className="inner_img" />
                        </div>
                        <div className="overlay"></div>
                      </div>

                      <div className="info_holder">
                        <p className="project_name">{item?.project}</p>
                        <p className="loactaion">{item?.location}</p>
                        <p className="loactaion">{item?.year}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Our_Projects;
